export const DEFAULT_SESSION_LIFETIME = 300;
export const DEFAULT_DEVICE_MODEL_NAME = 'TAP VIRTUAL 1.0';
export const DEVICE_MANUFACTURER = 'IoTize';
export const DEFAULT_HASH_ITERATION = 2000;
export const DEFAULT_HOST_INACTIVITY_PERIOD = 30;
